import Phaser from 'phaser';
import { CST } from '../../../CST';
import { Score } from '../../../controller/score.js';

var pos = 0;

export default class Storyboard_5 extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.STORYBOARD_5);
	}

	init() {
		pos = 0;
	}

	preload() {
		this.load.image('games-with-grandpa-bg', 'assets/Storyboards/gameswithgrandpa_background.png');
	}

	create(data) {
		const map = this.add.image(0, 0, 'games-with-grandpa-bg').setOrigin(0);

		const cam = this.cameras.main;
		cam.setBounds(0, 0, 4401, 14647); //Left, Top, X Limit, Y Limit
		cam.setZoom(0.35); //0.8
		cam.centerOn(0, 0); //1100, 800

		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});

		this.score = new Score(this);
		this.User_ID = data.User_ID;

		data.next
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos++;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 1:
							cam.pan(0, 2260, 1000);
							break;
						case 2:
							cam.pan(0, 4200, 1000);
							break;
						case 3:
							cam.pan(0, 5900, 1000);
							break;
						case 4:
							cam.pan(0, 8000, 1000);
							break;
						case 5:
							cam.pan(0, 10150, 1000);
							break;
						case 6:
							cam.pan(0, 11800, 1000);
							break;
						case 7:
							cam.pan(0, 14647, 1000);
							break;
						case 8:
							pos = 0;
							data.next.setVisible(false);
							data.previous.setVisible(false);
							data.pause.setVisible(false);
							this.scene.resume(CST.SCENES.MAIN_QUESTIONS, {
								User_ID: this.User_ID,
								story: 5,
							});
							this.scene.stop();
							//this.scene.start(CST.SCENES.SIMONSAYS);
							break;
					}
				},
				this,
			);

		data.previous
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos--;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 0:
							cam.pan(0, 0, 1000);
							break;
						case 1:
							cam.pan(0, 2260, 1000);
							break;
						case 2:
							cam.pan(0, 4200, 1000);
							break;
						case 3:
							cam.pan(0, 5900, 1000);
							break;
						case 4:
							cam.pan(0, 8000, 1000);
							break;
						case 5:
							cam.pan(0, 10150, 1000);
							break;
						case 6:
							cam.pan(0, 11800, 1000);
							break;
						case 7:
							cam.pan(0, 14647, 1000);
							break;
					}
				},
				this,
			);
	}
}
